import { FilterTypes } from 'Core/interfaces'

import { UrlParams } from 'Portals/Supplier/constants'
import { SiteVisit, SiteVisitFilterFields } from 'Portals/Supplier/entities'
import i18n from 'Portals/Supplier/utils/i18nService'

export const getFilterConfig = (): SiteVisit.Filter.Config => ({
	[SiteVisitFilterFields.supplierLocationId]: {
		label: i18n.t('pages:siteVisit.filters.supplierLocationId'),
		apiFilterFieldName: SiteVisitFilterFields.supplierLocationId,
		filterType: FilterTypes.VALUE,
		UrlParam: UrlParams.supplierLocationId,
		defaultValue: ''
	}
})
